'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import { useTabContext } from '@/components/context/TabContext';
import { useCookieConsent } from '@/hooks/useCookieConsent';

export const GoogleTagManager = () => {
  const { selectedTab } = useTabContext();
  const { accepted: consentAccepted } = useCookieConsent();

  useEffect(() => {
    const chatWidgets = document.querySelectorAll('[id^="be-chat"]');

    chatWidgets.forEach(widget => {
      widget.style.display = selectedTab === 'customer' ? 'none' : '';
    });
  }, [selectedTab]);

  return (
    <>
      {/* Google Analytics - only load if consent is accepted */}
      {consentAccepted && (
        <>
          <Script async="" src="https://www.googletagmanager.com/gtag/js?id=G-0P15RRYZTT"></Script>
          <Script id="google-tag-manager" strategy="afterInteractive">
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag() {
              dataLayer.push(arguments);
            }
              gtag('js', new Date());
              gtag('config', 'G-0P15RRYZTT');
            `}
          </Script>
        </>
      )}

      {selectedTab === 'adviser' && (
        <Script id="professionals-chat" strategy="afterInteractive">
          {`
          (function (i, s, o, r, g, v, a, m) {
          g = v ? g + '?v=' + v : g;
          i['BrandEmbassy'] = r;
          i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments)
        };
          i[r].l = +new Date();
          a = s.createElement(o);
          m = s.getElementsByTagName(o)[0];
          a.async = 1;
          a.src = g + '?' + Math.round(Date.now() / 1000 / 3600);
          m.parentNode.insertBefore(a, m)
        })(window, document, 'script', 'brandembassy', 'https://livechat-static-de-uk1.niceincontact.com/4/chat.js');
          brandembassy('init', 1254, 'chat_adf317d0-78b1-4d13-b578-1b85364c4ded');
          `}
        </Script>
      )}

      <Script id="sugar-crm" strategy="afterInteractive">
        {`
          (function (a, b, c, d, e, m) {
          a['OktopostTrackerObject'] = d;
          a[d] = a[d] || function () {
          (a[d].q = a[d].q || []).push(arguments);
        };
          e = b.createElement('script');
          m = b.getElementsByTagName('script')[0];
          e.async = 1;
          e.src = c;
          m.parentNode.insertBefore(e, m);
        })(window, document, 'https://static.oktopost.com/oktrk.js', '_oktrk');
          _oktrk('create', '001okvseriatzqg', {domain: 'ok.pureretirement.co.uk'});
          `}
      </Script>
    </>
  );
};
